import { createContext, useContext, useState } from 'react';
import CustomSnackbar from '../components/CustomSnackbar';

const SnackbarContext = createContext();

export const useSnackbar = () => {
  return useContext(SnackbarContext);
};

export const SnackbarProvider = ({ children }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("error");
  // Counts the messages shown: a new one while another is up starts its own time on screen.
  const [shownCount, setShownCount] = useState(0);

  const showSnackbar = (message, severity = "error") => {
    setSnackbarMessage(message);
    setSeverity(severity);
    setShownCount((count) => count + 1);
    setSnackbarOpen(true);
  };

  const handleClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <SnackbarContext.Provider value={showSnackbar}>
      <CustomSnackbar
        key={shownCount}
        open={snackbarOpen}
        setOpen={handleClose}
        message={snackbarMessage}
        severity={severity}
      />
      {children}
    </SnackbarContext.Provider>
  );
};
